import {Injectable} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {environment} from '../../environments/environment';

@Injectable()

export class PageTitleService {

	public title: string = 'KVVM';

	constructor(private titleService: Title) {
	}

	setTitle(title: string = 'KVVM') {
		this.titleService.setTitle(title);
		this.title = title.replace(' | ' + environment.webappName, '');
	}

	setPageTitle(title: string = 'KVVM') {
		this.title = title.replace(' | ' + environment.webappName, '');
	}
}
